import { type Clip } from '@air/api/types';

import { ClipUtils } from './ClipUtils';

export const getAssetIsNonTranscodable = (asset?: { status?: Clip['status'] | null }) =>
  asset && ClipUtils.isNonTranscodable(asset.status);
